module.exports = __webpack_public_path__ + "static/media/band3.b13cee4e.jpg";